module.exports = __webpack_public_path__ + "static/media/capsule_fire.4cd6966f.svg";